import Paragraph from "antd/es/skeleton/Paragraph";
import { writer } from "repl";
import { blog_15, blog_16, blog_17, blog_18, blog_19, blog_21, doctor02 } from "../../constants/images";
import { sub } from "date-fns";
import { SubTitle } from "../../style/base.style";

export const articles = [
    {
        id:1,
        title:"article1_title",
        img:blog_17,
        mainTag:"tag_health_tips",
        tags:["tag_health_tips","tag_health"],
        createdOn:"2025-03-15T21:10:30+00:00",
        writer:"writer_elder",
        writerImg:doctor02,
        Paragraphs:[
            {
                type:"regular",
                content:"article1_paragraph1_content",
            },
            {
                type:"regular",
                content:"article1_paragraph2_content",
            },
            {
                type:"bold",
                content:"article1_paragraph3_content",
            },
        ]

    },
    {
        id:2,
        title:"article2_title",
        img:blog_21,
        mainTag:"tag_health_tips",
        tags:["tag_health_tips","tag_health"],
        createdOn:"2025-03-15T21:10:30+00:00",
        writer:"writer_elder",
        writerImg:doctor02,
        Paragraphs:[
            {
                type:"regular",
                content:"article2_paragraph1_content",
            },
            {
                type:"regular",
                content:"article2_paragraph2_content",
            },
            {
                type:"bold",
                content:"article2_paragraph3_content",
            },
        ]

    },
    {
        id:3,
        title:"article3_title",
        img:blog_18,
        mainTag:"tag_health_tips",
        tags:["tag_health_tips","tag_health"],
        createdOn:"2025-03-15T21:10:30+00:00",
        writer:"writer_elder",
        writerImg:doctor02,
        Paragraphs:[
            {
                type:"regular",
                content:"article3_paragraph1_content",
            },
            {
                type:"regular",
                content:"article3_paragraph2_content",
            },
            {
                type:"bold",
                content:"article3_paragraph3_content",
            },
        ]

    },
    {
        id:4,
        title:"article4_title",
        img:blog_19,
        mainTag:"tag_health_tips",
        tags:["tag_health_tips","tag_health"],
        createdOn:"2025-03-15T21:10:30+00:00",
        writer:"writer_elder",
        writerImg:doctor02,
        Paragraphs:[
            {
                type:"regular",
                content:"article4_paragraph1_content",
            },
            {
                type:"regular",
                content:"article4_paragraph2_content",
            },
            {
                type:"bold",
                content:"article4_paragraph3_content",
            },
        ]

    },
    {
        id:5,
        title:"article5_title",
        img:blog_15,
        mainTag:"home_medicare",
        tags:["home_medicare","tag_health"],
        createdOn:"2025-03-15T21:10:30+00:00",
        writer:"writer_elder",
        writerImg:blog_15,
        Paragraphs:[
            {
                type:"regular",
                content:"article5_paragraph1_content",
            },
            {
                type:"regular",
                content:"article5_paragraph2_content",
            },
            {
                type:"regular",
                subTitle:"article5_paragraph3_title",
                content:"article4_paragraph3_content",
            },
            {
                type:"regular",
                content:"article5_paragraph4_content",
            },
            {
                type:"regular",
                subTitle:"article5_paragraph5_title",
                content:"article5_paragraph5_content",
            },
            {
                type:"regular",
                content:"article5_paragraph6_content",
            },
            {
                type:"regular",
                subTitle:"article5_paragraph7_title",
                content:"article5_paragraph7_content",
            },
            {
                type:"regular",
                content:"article5_paragraph8_content",
            },
            {
                type:"regular",
                subTitle:"article5_paragraph9_title",
                content:"article5_paragraph9_content",
            },
            {
                type:"regular",
                content:"article5_paragraph10_content",
            },
        ]

    },
    {
        id: 6,
        title: "article6_title",
        img: blog_16,
        mainTag: "complementary_medicine",
        tags: ["complementary_medicine", "tag_health"],
        createdOn: "2025-04-11T00:00:00+00:00",
        writer: "writer_elder",
        writerImg: blog_16,
        Paragraphs: [
          {
            type: "regular",
            content: "article6_paragraph1_content",
          },
          {
            type: "regular",
            content: "article6_paragraph2_content",
          },
          {
            type: "regular",
            subTitle: "article6_paragraph3_title",
            content: "article6_paragraph3_content",
          },
          {
            type: "regular",
            content: "article6_paragraph4_content",
          },
          {
            type: "regular",
            subTitle: "article6_paragraph5_title",
            content: "article6_paragraph5_content",
          },
          {
            type: "regular",
            content: "article6_paragraph6_content",
          },
          {
            type: "regular",
            subTitle: "article6_paragraph7_title",
            content: "article6_paragraph7_content",
          },
          {
            type: "regular",
            content: "article6_paragraph8_content",
          },
          {
            type: "regular",
            subTitle: "article6_paragraph9_title",
            content: "article6_paragraph9_content",
          },
          {
            type: "regular",
            content: "article6_paragraph10_content",
          }
        ]
      }
      
]